import type { RouteRecordRaw } from 'vue-router';
export const sustainabilityRoutes: RouteRecordRaw[] = [
  {
    path: 'sustainability/utilities',
    name: 'sustainability-utilities',
    component: () => import('../pages/sustainability/SustainabilityPage.vue'),
    meta: { requiresModule: 'sustainability' },
  },
];
